import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=573d3ed9&scoped=true"
import script from "./Period.vue?vue&type=script&lang=ts&setup=true"
export * from "./Period.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Period.vue?vue&type=style&index=0&id=573d3ed9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d3ed9",
  null
  
)

export default component.exports